import { Injectable, NgZone } from '@angular/core';
import { fromEvent, Subject } from 'rxjs';

@Injectable({
	providedIn: 'root',
})
export class ClickHandlerService {
	private clickSubject = new Subject<Event>();
	public click$ = this.clickSubject.asObservable();

	constructor(private ngZone: NgZone) {
		this.ngZone.runOutsideAngular(() => {
			fromEvent(document, 'click').subscribe((event: Event) => {
				this.ngZone.run(() => {
					this.clickSubject.next(event);
				});
			});
		});
	}
}
